import { css } from "@emotion/css";
import { Text } from "components/common";
import { UserContext } from "context";
import React, { forwardRef, useContext } from "react";
import { CARD_HEIGHT } from "utils/constants";
import { ShareBtn } from "./shareBtn";
import { SharableContent } from "./sharableContent";
import { Footer } from "./footer";
import Bg from "assets/share-1.png";

const offset = 50;

type Props = {
  handleNext?: VoidFunction;
  handleShare: (option: "twitter" | "facebook" | "linkedin") => void;
  index: number;
  ref: React.Ref<HTMLDivElement>;
  shareLoading?: boolean;
};

export const TotalEmailReceived = forwardRef<HTMLDivElement, Props>(
  ({ index, handleShare, shareLoading }, ref) => {
    const { state: userState } = useContext(UserContext);
    const [isShare, setIsShare] = React.useState(false);
    const onShare = (option: "twitter" | "facebook" | "linkedin") => {
      setIsShare(true);
      setTimeout(() => {
        handleShare(option);
        setIsShare(false);
      }, 1000);
    };
    return (
      <>
        <div
          className={css`
            border: 1.825px solid #29282f;
            height: calc(100vh - ${offset}px);
            max-height: calc(${CARD_HEIGHT}px - ${offset}px);
            width: 100%;
            border-radius: 40px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            padding: 50px 24px 65px 24px;
            transition: transform 0.3s;
            background-color: #151419;

            &:hover {
              transform: translateY(1px);
            }
            position: relative;
            overflow: hidden;
          `}
        >
          <Text.Body
            style={{
              fontSize: "28px",
              zIndex: 2,
              textAlign: "center",
              marginBottom: "8px",
            }}
          >
            In the last 365 days, you received
          </Text.Body>
          <Text.Body
            style={{
              marginBottom: "140px",
              marginTop: "5px",
              fontSize: "28px",
              color: "#AAEF65",
              zIndex: 2,
            }}
          >
            {userState?.emailStats?.totalEmailReceived} emails
          </Text.Body>
          {shareLoading ? (
            <Text.Body style={{ fontSize: "28px", zIndex: 2 }}>
              Sharing...
            </Text.Body>
          ) : (
            <ShareBtn handleShare={onShare} />
          )}

          <div
            style={{
              position: "absolute",
              top: "-10px",
            }}
          >
            <svg
              width="375"
              height="387"
              viewBox="0 0 375 387"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                width: "462px",
              }}
            >
              <g opacity=".5" filter="url(#a)">
                <g filter="url(#b)">
                  <circle
                    cx="187"
                    cy="104"
                    r="266"
                    fill="url(#c)"
                    fill-opacity=".6"
                    shape-rendering="crispEdges"
                  />
                </g>
                <g filter="url(#d)">
                  <circle
                    cx="187"
                    cy="171"
                    r="199"
                    fill="url(#e)"
                    fill-opacity=".6"
                    shape-rendering="crispEdges"
                  />
                </g>
                <g filter="url(#f)">
                  <circle cx="187" cy="171" r="199" fill="url(#g)" />
                </g>
                <g filter="url(#h)">
                  <circle
                    cx="186.667"
                    cy="237.667"
                    r="132.667"
                    fill="url(#i)"
                  />
                </g>
                <g filter="url(#j)">
                  <circle cx="187.333" cy="303.333" r="66.333" fill="url(#k)" />
                </g>
              </g>
              <defs>
                <filter
                  id="a"
                  x="-85"
                  y="-168"
                  width="544"
                  height="544.333"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="3"
                    result="effect1_foregroundBlur_6234_4622"
                  />
                </filter>
                <filter
                  id="b"
                  x="-89.414"
                  y="-172.414"
                  width="552.828"
                  height="552.828"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="5.207" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                  <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6234_4622"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6234_4622"
                    result="shape"
                  />
                </filter>
                <filter
                  id="d"
                  x="-22.61"
                  y="-38.61"
                  width="419.22"
                  height="419.22"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="5.305" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                  <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6234_4622"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6234_4622"
                    result="shape"
                  />
                </filter>
                <filter
                  id="f"
                  x="-22.613"
                  y="-38.613"
                  width="419.227"
                  height="419.227"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="5.307" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                  <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6234_4622"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6234_4622"
                    result="shape"
                  />
                </filter>
                <filter
                  id="h"
                  x="38.08"
                  y="89.08"
                  width="297.173"
                  height="297.173"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="7.96" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                  <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6234_4622"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6234_4622"
                    result="shape"
                  />
                </filter>
                <filter
                  id="j"
                  x="110.387"
                  y="226.387"
                  width="153.893"
                  height="153.893"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset />
                  <feGaussianBlur stdDeviation="5.307" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
                  <feBlend
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_6234_4622"
                  />
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_6234_4622"
                    result="shape"
                  />
                </filter>
                <radialGradient
                  id="c"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="matrix(223.38132 -373.54919 681.60958 407.60053 106.973 230.253)"
                >
                  <stop stop-color="#10004D" />
                  <stop offset=".109" stop-color="#372B89" />
                  <stop offset=".264" stop-color="#4830A3" />
                  <stop offset=".401" stop-color="#5945C4" />
                  <stop offset=".54" stop-color="#6A53FE" />
                  <stop offset=".623" stop-color="#7668FF" />
                  <stop offset=".707" stop-color="#8B7EFF" />
                  <stop offset=".767" stop-color="#9A90FF" />
                  <stop offset=".849" stop-color="#B3AFFF" />
                  <stop offset=".922" stop-color="#C8CFFF" />
                  <stop offset=".97" stop-color="#E3EBFF" />
                  <stop offset="1" stop-color="#FFFFFF" />
                </radialGradient>
                <radialGradient
                  id="e"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="rotate(-59.121 297.583 20.651)scale(325.615 594.146)"
                >
                  <stop stop-color="#10004D" />
                  <stop offset=".109" stop-color="#372B89" />
                  <stop offset=".264" stop-color="#4830A3" />
                  <stop offset=".401" stop-color="#5945C4" />
                  <stop offset=".54" stop-color="#6A53FE" />
                  <stop offset=".623" stop-color="#7668FF" />
                  <stop offset=".707" stop-color="#8B7EFF" />
                  <stop offset=".767" stop-color="#9A90FF" />
                  <stop offset=".849" stop-color="#B3AFFF" />
                  <stop offset=".922" stop-color="#C8CFFF" />
                  <stop offset=".97" stop-color="#E3EBFF" />
                  <stop offset="1" stop-color="#FFFFFF" />
                </radialGradient>
                <radialGradient
                  id="g"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="rotate(-59.121 297.583 20.651)scale(325.615 594.146)"
                >
                  <stop stop-color="#10004D" />
                  <stop offset=".109" stop-color="#372B89" />
                  <stop offset=".264" stop-color="#4830A3" />
                  <stop offset=".401" stop-color="#5945C4" />
                  <stop offset=".54" stop-color="#6A53FE" />
                  <stop offset=".623" stop-color="#7668FF" />
                  <stop offset=".707" stop-color="#8B7EFF" />
                  <stop offset=".767" stop-color="#9A90FF" />
                  <stop offset=".849" stop-color="#B3AFFF" />
                  <stop offset=".922" stop-color="#C8CFFF" />
                  <stop offset=".97" stop-color="#E3EBFF" />
                  <stop offset="1" stop-color="#FFFFFF" />
                </radialGradient>
                <radialGradient
                  id="i"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="rotate(-59.121 338.41 20.943)scale(217.077 396.097)"
                >
                  <stop stop-color="#10004D" />
                  <stop offset=".109" stop-color="#372B89" />
                  <stop offset=".264" stop-color="#4830A3" />
                  <stop offset=".401" stop-color="#5945C4" />
                  <stop offset=".54" stop-color="#6A53FE" />
                  <stop offset=".623" stop-color="#7668FF" />
                  <stop offset=".707" stop-color="#8B7EFF" />
                  <stop offset=".767" stop-color="#9A90FF" />
                  <stop offset=".849" stop-color="#B3AFFF" />
                  <stop offset=".922" stop-color="#C8CFFF" />
                  <stop offset=".97" stop-color="#E3EBFF" />
                  <stop offset="1" stop-color="#FFFFFF" />
                </radialGradient>
                <radialGradient
                  id="k"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="matrix(55.7046 -93.15307 169.97616 101.64404 167.379 334.818)"
                >
                  <stop stop-color="#10004D" />
                  <stop offset=".109" stop-color="#372B89" />
                  <stop offset=".264" stop-color="#4830A3" />
                  <stop offset=".401" stop-color="#5945C4" />
                  <stop offset=".54" stop-color="#6A53FE" />
                  <stop offset=".623" stop-color="#7668FF" />
                  <stop offset=".707" stop-color="#8B7EFF" />
                  <stop offset=".767" stop-color="#9A90FF" />
                  <stop offset=".849" stop-color="#B3AFFF" />
                  <stop offset=".922" stop-color="#C8CFFF" />
                  <stop offset=".97" stop-color="#E3EBFF" />
                  <stop offset="1" stop-color="#FFFFFF" />
                </radialGradient>
              </defs>
            </svg>
          </div>
        </div>

        {isShare && (
          <SharableContent>
            <div
              ref={ref}
              data-value={index}
              className={css`
                width: 560px;
                height: 700px;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                padding: 50px 24px 65px 24px;
                transition: transform 0.3s;
                background-color: #151419;
                background: url(${Bg});
                background-repeat: no-repeat;
                background-position: top 0px left 0px;
                background-size: 100% auto;
                background-color: #151419;
                position: relative;
                top: 0;
                left: 0;
                overflow: hidden;
              `}
            >
              <Text.Body
                style={{
                  marginBottom: "42px",
                  marginTop: "5px",
                  fontSize: "100px",
                  color: "#AAEF65",
                  zIndex: 2,
                }}
              >
                {userState?.emailStats?.totalEmailReceived}
              </Text.Body>

              <Text.Body
                style={{ fontSize: "30px", zIndex: 2, marginBottom: "82px" }}
              >
                My 2024 email count
              </Text.Body>

              <Footer />
            </div>

            {/* <StatsSummary /> */}
          </SharableContent>
        )}
      </>
    );
  },
);
